/**
 * File Name          : fw-images.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

export const LATEST_FW_IMAGE = "datasnap_mcuboot_image_v0_5_2_m2_dev_release.signed.encrypted.bin";
export const LATEST_FW_VERSION = {
  versionMajor: 0,
  versionMinor: 5,
  versionBug: 2,
  versionSpecial: 0
}